import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=06957cd8&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=06957cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06957cd8",
  null
  
)

export default component.exports